import moment from "moment/moment";
import {DatePicker, Form, InputNumber, Space, Tag} from "antd";
import React, {useEffect, useMemo, useState} from "react";
import SPButton from 'components/carRental/base/SPButton';
import {useCarModelPrice} from "../../../../../../hooks/product-price/car-model-price";
import {jsonParseData} from "../../../../../../utils";
function getDate(datestr: string) {
    var temp: any = datestr.split("-");
    var date = new Date(temp[0], temp[1] - 1, temp[2]);
    return date;
}

function getAll(start: any, end: any) {
    let dateList = [];
    var startTime = getDate(start);
    var endTime = getDate(end);

    while ((endTime.getTime() - startTime.getTime()) >= 0) {
        var year = startTime.getFullYear();
        var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
        var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
        dateList.push(year + "-" + month + "-" + day);
        startTime.setDate(startTime.getDate() + 1);
    }
    return dateList;
}


const ChooseRangDay = (props:any) => {
    const form = Form.useFormInstance();
    const { value, onChange, enums } = props || {};
    const [price, setPrice] = useState<any>(null)
    const [dateArr, setDateArr] = useState<any>([])
    const [holidayList, setHolidayList] = useState<any>([])
    const { getSaasApolloConfig } = useCarModelPrice();

    const handlePickerChange = (date:any, dateStrings: any) => {
        const res = getAll(dateStrings[0], dateStrings[1])
        setDateArr(res)
    }
    const changePrice = (e: any) => {
        setPrice(e)
    }

    const dayMaxNum = useMemo(() => {
        const res = enums?.['f_max_num_car_price']?.find((item: any) => { return item.value === 'day_price_max' })
        return res?.key || 5000
    }, [enums])

    useEffect(() => {
        const res = dateArr.map((item: any) => {
            return {
                day: item,
                price: price * 100  // 元转分
            }
        })
        onChange(res)
    }, [price, dateArr]);

    useEffect(() => {
        getSaasApolloConfig({
            config_name: 'front_enums',
            param_name: 'f_holiday_enum',
        }).then((res: any) => {
            try {
                const list =  filterUpcomingHolidays(jsonParseData(res?.data?.f_holiday_enum, []))
                setHolidayList(list)
            } catch (e) {
                console.log(e);
            }

        })
    }, []);

    const filterUpcomingHolidays = (holidays: any[]) => {
        const currentDate = new Date();
        const threeMonthsLater = new Date();
        threeMonthsLater.setMonth(currentDate.getMonth() + 3);

        return holidays.filter(holiday => {
            const startDate = new Date(holiday.date_ranges[0]);
            return startDate >= currentDate && startDate <= threeMonthsLater;
        });
    }

    const tagClick = (item: any) => {
        const date_ranges: any = item.date_ranges
        if (Array.isArray(date_ranges)) {
            const res = getAll(date_ranges[0], date_ranges[1]);
            form.setFieldValue('a', [moment(date_ranges[0]), moment(date_ranges[1])])
            setDateArr(res)
        }
    }


    return (
        <>
            <Form.Item label={'日期'} labelCol={{ span: 8 }} name={['a']} rules={[{required: true, message: '请选择日期区间'}]}  style={{
                width: '600px' }}>
                <Space>
                    <Form.Item noStyle label={'日期'} labelCol={{ span: 8 }} name={['a']} rules={[{required: true, message: '请选择日期区间'}]}  style={{
                    }}>
                        <DatePicker.RangePicker format='YYYY-MM-DD' onChange={handlePickerChange} />
                    </Form.Item>
                    {
                        holidayList?.map?.((item: any) => {
                            return  <SPButton type="dashed" onClick={() => {
                                tagClick(item)
                            }}>{item.name}</SPButton>
                        })
                    }
                </Space>
            </Form.Item>
            <Form.Item label={'价格'} labelCol={{ span: 8 }} name={['b']}
                       rules={[
                           {required: true, message: '请输入价格' },
                           { type: 'number',min: 1, max: dayMaxNum, message: `请输入1-${dayMaxNum}的正整数` },
                       ]}  style={{
                width: '600px' }}>
                <InputNumber
                    style={{width: '100%'}}
                    placeholder={'请输入价格'}
                    onChange={changePrice} addonAfter={'元/天'}></InputNumber>

            </Form.Item>
        </>
    );
}

export default ChooseRangDay;
